import { styled } from '@mui/material/styles';
import { TableCell as MuiTableCell, TableCellProps as MuiTableCellProps } from '@mui/material';

const TableActionsCell = styled(MuiTableCell)<MuiTableCellProps>(() => ({
	padding: '10px 12px',
}));

export default TableActionsCell;
